import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CarouselComp from "./CarouselComp";
import MastercardLogo from "../../../icons/mastercardLogo.svg";
import CardElypse from "../../../icons/cardelypse.png";
import VisaLogo from "../../../icons/visaLogo.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";
import UpdateCardPaymentModal from "../../../shared/Modal/UpdateCardPaymentModal";
import UpdateBankPaymentModal from "../../../shared/Modal/UpdateBankPaymentModal";
import DBPayMethodLogo from "../../../icons/DBPayMethod.svg";
import CCPayMethodLogo from "../../../icons/CCPayMethod.svg";
import BankPayMethodLogo from "../../../icons/BankPayMethod.svg";
import Amex from "../../../icons/AMEX.svg";
import Discover from "../../../icons/Discover.svg";
import { clearBankAndCardStates } from "../sagas/residentpaymentsSlice";
import formatedDate from "../../../shared/util/formatCardDate";
import { Box } from "@mui/system";

const useStyles = makeStyles({
  carouselContainer: {
    margin: "0 0 1.125rem 0",
  },
  cardNumber: {
    marginLeft: "14px",
  },
});

export default function Catalog(props: any) {
  return (
    <Grid container>
      <CarouselWrapperRect data={props.methods || []} />
    </Grid>
  );
}

const CarouselWrapperRect = (props: { data: any }) => {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:600px)");
  const matchesIpad = useMediaQuery("(max-width:786px)");
  const [data, setData] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (props.data?.length) {
      const newArray = [];
      const newData = [...props.data];
      
      while (newData.length > 0) {
        if (matchesMobile) {
          newArray.push(newData.splice(0, 2));
        } else if (matchesIpad) {
          newArray.push(newData.splice(0, 3));
        } else {
          newArray.push(newData.splice(0, 4));
        }
      }

      setData(newArray);
    }
  }, [props.data, matchesMobile, matchesIpad])

  return (
    <Grid item container>
      <Grid item container className={classes.carouselContainer}>
        <CarouselComp>
          {data.map((each: any, index) => (
            <CarouselSlideRect newData={each} key={index} />
          ))}
        </CarouselComp>
      </Grid>
    </Grid>
  );
};
const CarouselSlideRect = (props: { newData: any }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [openDb, setOpenDb] = React.useState(false);
  const [openBankModal, setOpenBankModal] = React.useState(false);
  let payMethod: any = {};
  const [selectedBankMethod, setSelectedBankMethod] = React.useState(payMethod);
  const [selectedCCMethod, setSelectedCCMethod] = React.useState(payMethod);
  const [selectedDBMethod, setSelectedDBMethod] = React.useState(payMethod);

  const matchesMobile = useMediaQuery("(max-width:600px)");
  const matchesIpad = useMediaQuery("(max-width:786px)");

  const handleOpenCC = (payMethod: any) => {
    setSelectedCCMethod(payMethod);
    setOpen(true);
  };
  const handleOpenDb = (payMethod: any) => {
    setSelectedDBMethod(payMethod);
    setOpenDb(true);
  };
  const handleCloseCC = () => {
    setSelectedCCMethod({});
    setOpen(false);
  };
  const handleCloseDb = () => {
    setSelectedDBMethod({});
    setOpenDb(false);
  };
  const handleOpenBankModal = (payMethod: any) => {
    setSelectedBankMethod(payMethod);
    setOpenBankModal(true);
  };
  const handleCloseBankModal = () => {
    setSelectedBankMethod({});
    setOpenBankModal(false);
  };
  const classes = useStyles();

  React.useEffect(() => {
    dispatch({
      type: clearBankAndCardStates.type,
    });
  }, [dispatch]);

  const setLogo = (method: any): string => {
    switch (method.CardNetwork?.toLowerCase()) {
      case 'visa':
        return VisaLogo;
      case 'mastercard':
        return MastercardLogo;
      case 'amex':
      case 'american express':
        return Amex;
      case 'discover':
        return Discover;
        default:
      return VisaLogo
    }
  };

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={matchesMobile ? 2 : 1}
      sx={{
        width: matchesMobile ? "370px" : !matchesMobile && matchesIpad ? "400px" : "425px",
        margin: "0px auto",
        marginLeft: matchesMobile ? "-25px" : "auto",
      }}
    >
      {props.newData.map((each: any, index: number) => {
        if (each?.AccountType === "C" || each?.AccountType === "S") {
          return (
            <Grid
              item
              xs={3}
              key={index}
              sx={{
                backgroundImage: `url(${BankPayMethodLogo})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100px 152px",
                height: "152px",
                minWidth: "100px",
                cursor: "pointer",
              }}
              onClick={() => {
                handleOpenBankModal(each);
              }}
              className={`bank${each.AccountLastFour} pay-method-item`}
            >
              <Typography
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  textAlign: "left",
                  lineHeight: "21px",
                  color: "#000000",
                  marginLeft: "11px",
                  marginBottom: "15px",
                  paddingTop: "40px",
                  height: 61,
                }}
              >
                {each?.NickName ? `${each?.NickName.slice(0, 9)}...` : ""}
              </Typography>

              <Typography
                id="card-number"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  lineHeight: "21px",
                  color: "#14142B",
                  marginLeft: "10px",
                  paddingTop: "45px",
                }}
              >
                <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" />
                {"  "}
                <span className={classes.cardNumber}>{each?.AccountLastFour && each?.AccountLastFour}</span>
              </Typography>
            </Grid>
          );
        }
        if (each?.CardType === "CC") {
          return (
            <Grid
              item
              xs={3}
              key={index}
              sx={{
                backgroundImage: `url(${CCPayMethodLogo})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100px 152px",
                height: "152px",
                minWidth: "100px",
                cursor: "pointer",
              }}
              onClick={() => {
                handleOpenCC(each);
              }}
              className={`card${each.AccountLastFour} pay-method-item`}
            >
              <Box sx={{ width: "100%", alignItems: "flex-start", textAlign: "left" }}>
                <img
                  src={setLogo(each)}
                  alt="visa-logo"
                  style={{
                    marginLeft: "9px",
                    marginTop: "15%",
                    marginBottom: "5%",
                    height: "12px",
                  }}
                />
              </Box>
              <Typography
                id="nick-name"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  textAlign: "left",
                  lineHeight: "21px",
                  color: "#000000",
                  marginLeft: "10px",
                  marginBottom: "15px",
                  height: 21,
                }}
              >
                {each?.NickName ? `${each?.NickName.slice(0, 9)}...` : ""}
              </Typography>
              <Typography
                id="card-name"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14px",
                  textAlign: "left",
                  color: "#14142B",
                  opacity: 0.5,
                  marginLeft: "10px",
                }}
              >
                {each?.CardNetwork}
              </Typography>
              <Typography
                id="card-number"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  lineHeight: "21px",
                  color: "#14142B",
                  marginLeft: "8px",
                  marginBottom: "10px",
                }}
              >
                <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" />
                {"  "}
                <span className={classes.cardNumber}>{each.AccountLastFour}</span>
              </Typography>
              <Typography
                id="cardDates"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "18px",
                  color: "#14142B",
                  textAlign: "right",
                  marginLeft: "51px",
                  marginRight: "6px",
                }}
              >
                {formatedDate(each.ExpirationDate)}
              </Typography>
            </Grid>
          );
        }
        if (each?.CardType === "DB") {
          return (
            <Grid
              item
              xs={3}
              key={index}
              sx={{
                backgroundImage: `url(${DBPayMethodLogo})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100px 152px",
                height: "152px",
                minWidth: "100px",
                cursor: "pointer",
              }}
              onClick={() => {
                handleOpenDb(each);
              }}
              className={`card${each.AccountLastFour} pay-method-item`}
            >
              <Box sx={{ width: "100%", alignItems: "flex-start", textAlign: "left" }}>
                <img src={setLogo(each)} alt="visa-logo" style={{ marginLeft: "9px", marginTop: "15%", marginBottom: "5%", height: "12px" }} />
              </Box>
              <Typography
                id="nick-name"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  textAlign: "left",
                  lineHeight: "21px",
                  color: "#000000",
                  marginLeft: "10px",
                  marginBottom: "15px",
                  height: 21,
                }}
              >
                {each?.NickName ? `${each?.NickName.slice(0, 9)}...` : ""}
              </Typography>
              <Typography
                id="card-name"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  textAlign: "left",
                  lineHeight: "14px",
                  color: "#14142B",
                  opacity: 0.5,
                  marginLeft: "10px",
                }}
              >
                {each?.CardNetwork}
              </Typography>
              <Typography
                id="card-number"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "13px",
                  lineHeight: "21px",
                  color: "#14142B",
                  marginLeft: "8px",
                  marginBottom: "10px",
                }}
              >
                <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" /> <img src={CardElypse} alt="" />
                {"  "}
                <span className={classes.cardNumber}>{each?.AccountLastFour}</span>
              </Typography>
              <Typography
                id="cardDates"
                style={{
                  fontFamily: "'Work Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "11px",
                  lineHeight: "18px",
                  color: "#14142B",
                  textAlign: "right",
                  marginLeft: "51px",
                  marginRight: "6px",
                }}
              >
                {formatedDate(each?.ExpirationDate)}
              </Typography>
            </Grid>
          );
        }
        return null;
      })}

      {Object.keys(selectedBankMethod).length !== 0 ? (
        <UpdateBankPaymentModal
          open={openBankModal}
          handleClose={handleCloseBankModal}
          nickName={selectedBankMethod?.NickName}
          billingAddress={selectedBankMethod?.BillingAddress}
          accountLastFour={selectedBankMethod?.AccountLastFour}
          names={`${selectedBankMethod?.AccountHolderFirstname ? selectedBankMethod?.AccountHolderFirstname : ""} ${selectedBankMethod?.AccountHolderLastname ? selectedBankMethod?.AccountHolderLastname : ""}`}
          bankName={selectedBankMethod?.BankName}
          accountType={selectedBankMethod?.AccountType}
          routingNumber={selectedBankMethod?.RoutingNumber}
          uuid={selectedBankMethod?.Uuid}
        />
      ) : (
        <></>
      )}

      {Object.keys(selectedCCMethod).length !== 0 ? (
        <UpdateCardPaymentModal
          open={open}
          handleClose={handleCloseCC}
          cardNetwork={selectedCCMethod?.CardNetwork}
          cardOwner={selectedCCMethod?.NickName}
          lastFour={selectedCCMethod.AccountLastFour}
          expiration={`${selectedCCMethod?.ExpirationDate.slice(0,2)}/${selectedCCMethod?.ExpirationDate.slice(2)}`}
          names={`${selectedCCMethod.CardholderFirstname} ${selectedCCMethod.CardholderLastname}`}
          cardType={selectedCCMethod.CardNetwork}
          country={selectedCCMethod?.BillingAddress?.Country}
          city={selectedCCMethod?.BillingAddress?.City}
          state={selectedCCMethod?.BillingAddress?.State}
          zip={selectedCCMethod?.BillingAddress?.Zip}
          address={selectedCCMethod?.BillingAddress?.Line1}
          uuid={selectedCCMethod?.Uuid}
        />
      ) : (
        <></>
      )}

      {Object.keys(selectedDBMethod).length !== 0 ? (
        <UpdateCardPaymentModal
          open={openDb}
          handleClose={handleCloseDb}
          cardOwner={selectedDBMethod?.NickName}
          lastFour={selectedDBMethod?.AccountLastFour}
          expiration={`${selectedDBMethod?.ExpirationDate.slice(0,2)}/${selectedDBMethod?.ExpirationDate.slice(2)}`}
          names={`${selectedDBMethod?.CardholderFirstname} ${selectedDBMethod?.CardholderLastname}`}
          cardNetwork={selectedDBMethod?.CardNetwork}
          cardType={selectedDBMethod?.CardType}
          country={selectedDBMethod?.BillingAddress?.Country}
          city={selectedDBMethod?.BillingAddress?.City}
          state={selectedDBMethod?.BillingAddress?.State}
          zip={selectedDBMethod?.BillingAddress?.Zip}
          address={selectedDBMethod?.BillingAddress?.Line1}
          uuid={selectedDBMethod?.Uuid}
        />
      ) : (
        <></>
      )}
    </Stack>
  );
};
